// extracted by mini-css-extract-plugin
module.exports = {"container_error":"Error_container_error__zcI7W","logo":"Error_logo__38Wny","content_error":"Error_content_error__zufIP"};